<template>
  <div class="ag-grafico-coluna">
    <div v-if="loading" class="w-100">
      <div class="ag-grafico-coluna__skeleton--heading">
        <v-skeleton-loader type="heading" />
      </div>
      <div class="ag-grafico-coluna__skeleton--text">
        <v-skeleton-loader type="text" />
        <v-skeleton-loader type="text" />
        <v-skeleton-loader type="text" />
        <v-skeleton-loader type="text" />
        <v-skeleton-loader type="text" />
      </div>
      <div class="d-flex flex-row">
        <div class="ag-grafico-coluna__skeleton--text"></div>
        <div class="ag-grafico-coluna__skeleton--text">
          <v-skeleton-loader type="text" />
        </div>
        <div class="ag-grafico-coluna__skeleton--text">
          <v-skeleton-loader type="text" />
        </div>
        <div class="ag-grafico-coluna__skeleton--text">
          <v-skeleton-loader type="text" />
        </div>
        <div class="ag-grafico-coluna__skeleton--text">
          <v-skeleton-loader type="text" />
        </div>
        <div class="ag-grafico-coluna__skeleton--text">
          <v-skeleton-loader type="text" />
        </div>
        <div class="ag-grafico-coluna__skeleton--text">
          <v-skeleton-loader type="text" />
        </div>
      </div>
    </div>
    <template v-else>
      <div class="d-flex flex-row justify-space-between align-center h-100 w-100">
        <div class="ag-grafico-coluna__title">{{ title }}</div>
        <AGTooltip
          v-if="tooltip"
          large-tooltip-title="Informação"
          large-tooltip-icon="mdi-information-outline"
          large-tooltip
        >
          <template #largeTooltipContent>
            <div v-html="tooltip"></div>
          </template>
          <AGIcon icon="mdi-information-outline" color="primary" size="24px" />
        </AGTooltip>
      </div>

      <ApexCharts
        class="ag-grafico-linha__chart"
        type="bar"
        height="350"
        :options="mergedOptions"
        :series="mergedOptions.series"
      ></ApexCharts>
    </template>
  </div>
</template>

<script>
import AGIcon from '@/components/common/AGIcon.vue';
import AgTooltipOld from '@/components/common/AGTooltipOld.vue';
import { merge } from 'lodash';
import ApexCharts from 'vue3-apexcharts';

export default {
  components: { AGTooltip: AgTooltipOld, AGIcon, ApexCharts },
  props: {
    title: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      default: null,
    },
    options: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      defaultOptions: {
        chart: {
          type: 'bar',
          locales: [{ name: 'pt-br' }],
          defaultLocale: 'pt-br',
          toolbar: {
            show: false,
          },
        },
        tooltip: {
          enabled: true,
          custom({ series, seriesIndex, dataPointIndex, w }) {
            const serieName = w.globals.seriesNames[seriesIndex];
            const value = w.globals.series[seriesIndex][dataPointIndex];
            const color = w.globals.colors[seriesIndex];

            return `<div class="ag-grafico-coluna__tooltip">
              <div class="apexcharts-tooltip__dot" style="background: ${color}"></div>
              <span class="px-1">${serieName}: ${value}</span>
            </div>`;
          },
        },
        plotOptions: {
          bar: {
            columnWidth: '24px',
            dataLabels: {
              position: 'top',
              orientation: 'horizontal',
            },
          },
        },
        dataLabels: {
          textAnchor: 'middle',
          offsetX: 0,
          offsetY: -18,
          style: {
            colors: ['#52526B'],
            fontSize: '12px',
          },
        },
        legend: {
          offsetX: 0,
          horizontalAlign: 'left',
          fontSize: '14px',
          fontFamily: 'Roboto',
          labels: {
            colors: '#52526B',
          },
        },
        xaxis: {
          labels: {
            style: {
              colors: '#52526B',
              fontSize: '14px',
              fontFamily: 'Roboto',
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: '#52526B',
              fontSize: '14px',
              fontFamily: 'Roboto',
            },
          },
        },
      },
    };
  },

  computed: {
    mergedOptions() {
      return merge({}, this.defaultOptions, this.options.fromModelToApexChart());
    },
  },
};
</script>

<style scoped lang="scss">
.ag-grafico-coluna {
  width: 100%;

  .ag-grafico-coluna__title {
    font-size: $font-size-sm;
  }

  .ag-grafico-coluna__chart {
    padding-bottom: 16px;
  }
}

:deep(.apexcharts-tooltip.apexcharts-theme-light) {
  background: transparent;
  border: none;
  box-shadow: none;
  padding: 0;
  .ag-grafico-coluna__tooltip {
    padding: 6px;
    background-color: $neutral-color-high-medium;
    border-radius: $border-radius-sm;
    color: $neutral-color-low-light;
  }
}

.ag-grafico-coluna__skeleton--heading {
  width: 25%;
}

.ag-grafico-coluna__skeleton--text {
  width: 15%;
}

:deep(.v-skeleton-loader__heading) {
  height: 32px;
}

:deep(.v-skeleton-loader__text) {
  height: 19px;
}
</style>
